import * as React from 'react';
import { Location, LocationParams } from 'lib/componentLocation';
import { IRoute } from 'lib/componentRouter';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { TopicCards, TopicCardsParams } from './model';
import { TopicCardsView } from './view';

export function TopicCardsRoute(
    model : (params : TopicCardsParams) => TopicCards,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <TopicCardsView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location) : TopicCardsParams {
    return {
        id: +(request.params['id'] || 0),
        selectedCard: request.params['templateId'] ?
            { TemplateId: +request.params['templateId']!, BerthId: +(request.params['berthId'] || 0) || null }
          : { CardId: +(request.params['cardId'] || 0) }
    };
}

function outboundParams(request : Location, m : TopicCards) {
    const params = {} as LocationParams;
    params['id'] = '' + m.Id;
    const sel = m.SelectedCardKey();
    if (sel.CardId) params['cardId'] = '' + sel.CardId;
    if (sel.TemplateId) params['templateId'] = '' + sel.TemplateId;
    if (sel.BerthId) params['berthId'] = '' + sel.BerthId;
    return new Location(request.name, params);
}


// WEBPACK FOOTER //
// ./apps/portcall/topiccards/route.tsx